import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { BRAND } from "../lib/constants";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white rounded-3xl border border-[#E2DAD0] p-8">
        <div className="text-center mb-6">
          <img src={BRAND.logo} alt="logo" className="h-16 w-16 rounded-full object-cover ring-2 ring-[#C5A059] mx-auto bg-white" />
          <h1 className="font-serif font-bold text-2xl text-[#1C2B20] mt-4">Forgot Password</h1>
          <p className="text-sm text-[#5A6B5D] mt-1">Enter your registered email to receive a reset link</p>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent-message">
            <CheckCircle2 size={44} className="text-[#1F4D2E] mx-auto" />
            <p className="text-[#1C2B20] font-medium mt-4">Check your inbox</p>
            <p className="text-sm text-[#5A6B5D] mt-2">
              If <b>{email}</b> is registered with us, we've sent a password reset link. The link expires in 1 hour.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-[#1F4D2E] font-medium hover:underline">
              <ArrowLeft size={16} /> Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#1C2B20] mb-1.5">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-email-input"
                className="w-full rounded-xl border border-[#E2DAD0] bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F4D2E]"
              />
            </div>
            {error && <p className="text-sm text-[#C86D51]">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full flex items-center justify-center gap-2 bg-[#1F4D2E] hover:bg-[#163A22] disabled:opacity-60 text-white font-medium rounded-full py-3 transition-colors"
            >
              {loading ? <Loader2 size={18} className="animate-spin" /> : <Mail size={16} />} Send Reset Link
            </button>
            <Link to="/login" className="block text-center text-sm text-[#1F4D2E] font-medium hover:underline">
              Back to Login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
